@if (isStaff()) {
  <button
    type="button"
    class="icon-btn bell"
    data-testid="bell"
    [attr.aria-label]="count() ? count() + ' records need a refresh request' : 'Price requests'"
    [attr.aria-expanded]="open()"
    (click)="toggle()">
    <ng-icon name="lucideBell" />
    <!--
      Hidden from screen readers because the button's own label already says
      the number in a sentence; read out on its own it is a bare digit beside
      the word "Price requests".
    -->
    @if (count()) {
      <span class="count" data-testid="bell-count" aria-hidden="true">{{ count() }}</span>
    }
  </button>

  @if (open()) {
    <div class="scrim" data-testid="bell-scrim" (click)="close()"></div>

    <div class="panel" data-testid="bell-panel" role="dialog" aria-label="Price requests">
      <p class="head">Needs attention</p>

      @for (group of liveGroups(); track group.kind) {
        <button
          type="button"
          class="group"
          data-testid="bell-group"
          (click)="openGroup(group)">
          <ng-icon [name]="icon(group.kind)" aria-hidden="true" />
          <span class="group-text">
            <span class="group-title">{{ group.title }}</span>
            <span class="group-sub">{{ group.candidates.length }} {{ group.description }}</span>
          </span>
          <span class="group-count">{{ group.candidates.length }}</span>
        </button>
      }

      @if (!liveGroups().length) {
        <p class="empty" data-testid="bell-empty">All up to date</p>
      }
    </div>
  }
}
